import { createSelector } from '@reduxjs/toolkit'

import { AppState } from '../reducer'

const learningStudioStateSelector = (state: AppState) => state.learningStudio

export const categoriesSelector = createSelector(learningStudioStateSelector, ({ categories }) => {
  const sortedList = categories?.slice()?.sort((a, b) => a?.parentname?.localeCompare(b?.parentname))
  return sortedList || []
})

export const categorySelector = createSelector(learningStudioStateSelector, ({ selectedCategory }) => selectedCategory)

export const categoriesStatusSelector = createSelector(
  learningStudioStateSelector,
  ({ categoriesStatus }) => categoriesStatus
)

export const categoryStatusSelector = createSelector(
  learningStudioStateSelector,
  ({ categoryStatus }) => categoryStatus
)

export const articleStatusSelector = createSelector(learningStudioStateSelector, ({ articleStatus }) => articleStatus)

export const categoryArticlesSelector = createSelector(learningStudioStateSelector, ({ selectedCategory }) => {
  const { blogParent } = selectedCategory || {}

  return blogParent?.blogPost.map(({ id, title, slug, coverImage }) => {
    return {
      id,
      title,
      articleUrl: slug,
      image: coverImage,
      category: {
        name: blogParent.parentname,
        url: blogParent.parentslug
      },
      isSlider: false
    }
  })
})

export const articleSelector = createSelector(learningStudioStateSelector, ({ selectedArticle }) => selectedArticle)
